
import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'
import { objectToForm } from '@/utils'

const buyInvoiceTransformer = ({xml, pdf, orders}) => {
  return objectToForm({
    xml_file: xml,
    pdf_file: pdf,
    orders: orders
  })
}

export default (payload) => {
  const config = { headers: {'Content-Type': 'multipart/form-data' }}
  return errorHandler(Vue.$http.post('purchase/buy_order_invoice/',
                        buyInvoiceTransformer(payload),
                        config))
    .then(request => {
      const { data } = request
      return data
    })}



// WEBPACK FOOTER //
// ./src/services/purchase/sendBuyOrderPayment.js